import { Icon, IconProps } from "@chakra-ui/react";

function HaltIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.3335 9.49967V5.49967M9.66683 9.49967V5.49967M14.6668 7.49967C14.6668 11.1816 11.6821 14.1663 8.00016 14.1663C4.31826 14.1663 1.3335 11.1816 1.3335 7.49967C1.3335 3.81778 4.31826 0.833008 8.00016 0.833008C11.6821 0.833008 14.6668 3.81778 14.6668 7.49967Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export default HaltIcon;
